import React, { createContext, useContext, useState, useCallback } from "react";
import { getLang, setLangGlobal, t as translate } from "../lib/i18n";

const LanguageContext = createContext({
    lang: "es",
    setLang: () => {},
    t: translate,
});

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(() => getLang());

    // Keep <html lang> / document.title in sync on first mount.
    React.useEffect(() => {
        setLangGlobal(lang);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const changeLang = useCallback((next) => {
        setLangGlobal(next);
        setLang(next);
    }, []);

    // Recreate a bound t() so components re-render when lang changes.
    const t = useCallback((key, vars) => translate(key, vars), [lang]);

    return (
        <LanguageContext.Provider value={{ lang, setLang: changeLang, t }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLang() {
    return useContext(LanguageContext);
}
